export default class Validator {

    static maximumMaterialSize = {
        w: 2050, h: 3050
    };
    static maximumCutModeLaserFrezSize = {
        w: 2030, h: 3030
    };
    static maximumChainPolishedSize = {
        w: 1990, h: 1990
    }
    static maximumWithElementsSize = {
        w: 2030, h: 3030
    }
    static maximumTextShapeSize = {
        w: 3030, h: 2020
    }
    static maximumOtherShapeSize = {
        w: 2030, h: 3030
    }

    static materialsMaxDimensions = {};

    static factory(mainShapeType) {
        switch (mainShapeType.name) {
            case 'Rect':
            case 'Rhombus':
            case 'Triangle':
                return new Validator();
            case 'RoundedRect':
                return new RoundedRectValidator();
            case 'Circle':
            case 'HalfCircle':
                return new CircleValidator();
            case 'QuarterCircle':
                return new QuarterCircleValidator();
            case 'Trapezoid':
                return new TrapezoidValidator();
            case 'Arrow':
                return new ArrowValidator();
            case 'Diamond':
                return new DiamondValidator();
            case 'Text':
                return new TextValidator();
        }
    }

    setActiveCutMode(activeCutMode) {
        this.activeCutMode = activeCutMode;
    }

    setData(data) {
        this.activeCutMode = data.activeCutMode;
        this.visibleElements = data.visibleElements;
        this.materialSettings = data.materialSettings.subType ? data.materialSettings.subType : data.materialSettings.type;
        this.materialSettingsTypeId = data.materialSettings.type ? data.materialSettings.type.id : null;
        this.materialSettingsSubTypeId = data.materialSettings.subType ? data.materialSettings.subType.id : null;
    }

    maxW() {
        let maxW = null;

        if (this.activeCutMode) {
            maxW = Validator.getMaxDimensionsForCutMode(this.activeCutMode.type.name, this.materialSettingsTypeId, this.materialSettingsSubTypeId).w;
        } else {
            maxW = this.maximumMaterialSize.w;
        }

        return maxW;
    }

    maxH() {
        let maxH = null;

        if (this.activeCutMode) {
            maxH = Validator.getMaxDimensionsForCutMode(this.activeCutMode.type.name, this.materialSettingsTypeId, this.materialSettingsSubTypeId).h;
        } else {
            maxH = this.maximumMaterialSize.h;
        }

        return maxH;
    }

    static setMaterialsMaxDimensions(items, shop_id = null) {
        this.materialsMaxDimensions = this.setMaterialMaxDimensions(items, shop_id);
    }

    static setMaterialMaxDimensions(items, shop_id = null) {
        let data = {};
        for (const item of items) {
            let max_width, max_height = null;
            if (shop_id && item.dimensions && item.dimensions[shop_id]) {
                max_width = item.dimensions[shop_id].max_width;
                max_height = item.dimensions[shop_id].max_height;
            } else {
                max_width = item.max_width;
                max_height = item.max_height;
            }
            data[item.id] = {
                'max_width': max_width,
                'max_height': max_height,
                'base_max_width': item.base_max_width,
                'base_max_height': item.base_max_height
            };
            if (item.items && item.items.length > 0) {
                data[item.id]['items'] = this.setMaterialMaxDimensions(item.items, shop_id);
            }
        }

        return data;
    }

    static getMaxDimensionsForCutMode(cutMode, materialTypeId = null, materialSubtypeId = null) {
        let maxW = null;
        let maxH = null;

        const materialMaxDim = this.getMaxDimensionsForMaterial(materialTypeId, materialSubtypeId);

        switch (cutMode) {
            case 'laser':
            case 'frez':
                maxW = materialMaxDim.baseW - 20;
                maxH = materialMaxDim.baseH - 20;
                break;
            case 'chainPolished':
                maxW = this.maximumChainPolishedSize.w;
                maxH = this.maximumChainPolishedSize.h;
                break;
            case 'chain':
                maxW = materialMaxDim.baseW;
                maxH = materialMaxDim.baseH;
                break;
            default:
                maxW = materialMaxDim.baseW;
                maxH = materialMaxDim.baseH;
        }

        if (materialMaxDim.w < maxW || !maxW) {
            maxW = materialMaxDim.w;
        }

        if (materialMaxDim.h < maxH || !maxH) {
            maxH = materialMaxDim.h;
        }

        return {w: maxW, h: maxH};
    }

    static getMaxDimensionsForMaterial(materialTypeId = null, materialSubtypeId = null) {
        let maxW = null;
        let maxH = null;
        let baseMaxW = null;
        let baseMaxH = null;

        if (materialTypeId) {
            if (materialSubtypeId) {
                maxW = this.materialsMaxDimensions[materialTypeId]['items'][materialSubtypeId]['max_width'];
                maxH = this.materialsMaxDimensions[materialTypeId]['items'][materialSubtypeId]['max_height'];
                baseMaxW = this.materialsMaxDimensions[materialTypeId]['items'][materialSubtypeId]['base_max_width'];
                baseMaxH = this.materialsMaxDimensions[materialTypeId]['items'][materialSubtypeId]['base_max_height'];
            }

            if (!maxW) {
                maxW = this.materialsMaxDimensions[materialTypeId]['max_width'];
                baseMaxW = this.materialsMaxDimensions[materialTypeId]['base_max_width'];
            }

            if (!maxH) {
                maxH = this.materialsMaxDimensions[materialTypeId]['max_height'];
                baseMaxH = this.materialsMaxDimensions[materialTypeId]['base_max_height'];
            }

            if (!maxW) {
                maxW = baseMaxW;
            }

            if (!maxH) {
                maxH = baseMaxH;
            }
        }

        if (!maxW) {
            baseMaxW = maxW = this.maximumMaterialSize.w;
        }

        if (!maxH) {
            baseMaxH = maxH = this.maximumMaterialSize.h;
        }

        return {w: maxW, h: maxH, baseW: baseMaxW, baseH: baseMaxH};
    }
}

class RoundedRectValidator extends Validator {
    maxR(model) {
        return Math.floor(Math.min(model.w, model.h) / 2);
    }
}

class CircleValidator extends Validator {
    maxD() {
        return this.maxW();
    }
}

class QuarterCircleValidator extends Validator {
    maxD() {
        return this.maxW();
    }
}

class TrapezoidValidator extends Validator {
    maxW(model) {
        return super.maxW() - model.t1 - model.t2;
    }

    maxT1(model) {
        return super.maxW() - model.w - model.t2;
    }

    maxT2(model) {
        return super.maxW() - model.w - model.t1;
    }
}

class ArrowValidator extends Validator {
    maxW(model) {
        return super.maxW() - model.w2;
    }

    maxW2(model) {
        return super.maxW() - model.w;
    }

    maxH(model) {
        return super.maxH() - 2 * model.t;
    }

    maxT(model) {
        return Math.floor((super.maxH() - model.h) / 2);
    }
}

class DiamondValidator extends Validator {
    maxH(model) {
        return super.maxH() - model.h2;
    }

    maxH2(model) {
        return super.maxH() - model.h;
    }
}

class TextValidator extends Validator {
    maxDimensions(model, boxWidth, boxHeight) {
        const aspectRatio = boxWidth / boxHeight;
        const heightScale = boxHeight / model.h;

        let maxW = this.getMaximumShapeSize().w;
        let maxH = this.getMaximumShapeSize().h;

        let newWidth = maxW;
        let newHeight = newWidth / aspectRatio;

        if (newHeight > maxH) {
            newHeight = maxH;
            newWidth = newHeight * aspectRatio;
        }

        newHeight = Math.round((newHeight / heightScale) - 1);

        return {maxWidth: newWidth, maxHeight: newHeight};
    }

    maxH(model, boxWidth, boxHeight) {
        const {maxWidth, maxHeight} = this.maxDimensions(model, boxWidth, boxHeight);
        return maxHeight;
    }

    getMaximumShapeSize() {
        let maxW = Validator.maximumTextShapeSize.w;

        if (this.materialSettings && this.materialSettings.max_height) {
            maxW = Math.min(maxW, this.materialSettings.max_height);
        }
        if (this.visibleElements && this.visibleElements > 0) {
            maxW = Math.min(maxW, Validator.maximumWithElementsSize.h);
        }

        let maxH = Validator.maximumTextShapeSize.h;

        if (this.materialSettings && this.materialSettings.max_width) {
            maxH = Math.min(maxH, this.materialSettings.max_width);
        }
        if (this.visibleElements && this.visibleElements > 0) {
            maxH = Math.min(maxH, Validator.maximumWithElementsSize.w);
        }

        return {
            'w': Math.min(Validator.maximumTextShapeSize.w, maxW),
            'h': Math.min(Validator.maximumTextShapeSize.h, maxH)
        };
    }

}
